/*
 * @Author: M.D.
 * @Date: 2019-12-24 17:05:37
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */
export const USR_TOKEN = '__kts__usr__token__'
